<template>
  <div class="media">
    <template v-if="isEditMode">
      <div class="media__image">
        <sc-image :media="scImageField || {}" />
      </div>
      <div v-if="videoSource">
        <div class="media__video-placeholder" />
      </div>
    </template>

    <template v-else>
      <div v-if="hasVideo">
        <client-only>
          <vimeo-video
            v-show="videoActive"
            :url="videoSource"
            :autoplay="videoAutoplay"
            :mute="videoMute"
            :loop="videoLoop"
            :default-controls="videoDefaultControls"
            :custom-controls="videoCustomControls"
            :hidden-text="videoHiddenText"
            :aspect-ratio="aspectRatio"
            :width="width"
            @error="handleVideoError"
            @ready="videoReady = true"
            @play="videoPlaybackStarted = true"
          />
        </client-only>
      </div>
      <cloudinary-image
        v-show="!videoActive"
        :aspect-ratio="aspectRatio"
        :image-alt="imageAlt"
        :image-source="imageDesktopSource"
        :mobile-source="imageMobileSource"
        :fraction="fraction"
        :round="round"
      />
    </template>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Image } from '@sitecore-jss/sitecore-jss-vue'
import VimeoVideo from '~/components/sitecore/vimeo-video'
import CloudinaryImage from '~/components/cloudinary-image'
import get from '~/helpers/get'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  components: {
    ScImage: Image,
    VimeoVideo,
    CloudinaryImage
  },

  props: {
    fraction: {
      type: Number
    },

    aspectRatio: {
      type: String
    },

    round: {
      type: Boolean
    },

    scImageField: {
      type: Object,
      default: () => {}
    },

    imageMobileSource: {
      type: String,
      default: ''
    },

    imageDesktopSource: {
      type: String,
      default: ''
    },

    videoSource: {
      type: String,
      default: ''
    },

    videoAutoplay: {
      type: Boolean,
      default: true
    },

    videoMute: {
      type: Boolean,
      default: true
    },

    videoLoop: {
      type: Boolean,
      default: false
    },

    videoDefaultControls: {
      type: Boolean,
      default: false
    },

    videoCustomControls: {
      type: Boolean,
      default: false
    },

    videoHiddenText: {
      type: String,
      default: ''
    },

    width: {
      type: Number
    },

    height: {
      type: Number
    }
  },

  data () {
    return {
      videoFailed: false,
      videoReady: false,
      videoPlaybackStarted: false
    }
  },

  computed: {
    ...mapJssGetters(['isEditMode']),

    hasVideo () {
      return this.videoSource && !this.videoFailed
    },

    videoActive () {
      return this.videoAutoplay ? this.videoPlaybackStarted : this.videoReady
    },

    imageAlt () {
      return get(this.scImageField, 'value.alt')
    }
  },

  methods: {
    handleVideoError (...e) {
      console.log('handle error', ...e)
      this.videoFailed = true
      this.$emit('media-error')
    }
  }
}
</script>

<style lang="scss" scoped>
  .media {
    &__video-placeholder {
      width: 100%;
      height: 100%;
      @include placeholder-image('https://res.cloudinary.com/soho-house/image/upload/f_auto,q_auto/v1593597890/digital-house-web/video-placeholder.jpg');
    }

    &__image {
      ::v-deep .sc-image-wrapper img {
        width: 100%;
        height: auto;
      }
    }
  }
</style>
